module.exports = __webpack_public_path__ + "img/Menu-13.53bfebc5.png";